import { DOMAINS } from '../entities';

export const isDomainHasIdentityConfig = (domain: string) => {
  return Object.values(DOMAINS).includes(domain as DOMAINS);
};
